import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_kwxjubcqph: FaireCollectionEntity = {
  token: "pbc_kwxjubcqph",
  type: "collection",
  name: "FW '26",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9886af0083da968ca389459719d2d63bc122d38cf84b3843eaedc7b6cd1dd433.jpeg",
  itemCount: 36,
  brandToken: "b_q8gu9by5sv",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:48:54.051Z",
    importedBy: "entity-db-import-collections",
  },
};
